import PlainInput from "./PlainInput";
import { COLORS, SIZES } from "./utilities";

export { COLORS, SIZES };
export default PlainInput;
